import styled from 'styled-components'

export const Wrapper = styled.div``

export const RankmiTableWrapper = styled.div`
  .rankmiTable-container > .ant-col {
    justify-content: flex-end;
  }
`
